import { FC } from 'react';
import { Button } from '@mui/material';
import {
  helpCenterCategoryItem,
  helpCenterCategoryItemActive
} from './HelpCenterCategoryItem.styles';

interface HelpCenterCategoryItemProps {
  categoryId: number;
  onClick: () => void;
  active: boolean;
  label: string;
}

export const HelpCenterCategoryItem: FC<HelpCenterCategoryItemProps> = ({
  categoryId,
  onClick,
  active,
  label
}) => (
  <Button
    type='button'
    role='tab'
    id={`help-center-category-${categoryId}`}
    aria-selected={active}
    aria-controls={`help-center-panel-${categoryId}`}
    variant='text'
    onClick={onClick}
    sx={[helpCenterCategoryItem, active && helpCenterCategoryItemActive]}
  >
    {label}
  </Button>
);
